export const GMAPS_TYPES = {
  STREET_NUMBER: 'street_number',
  ROUTE: 'route',
  PROVINCE: 'administrative_area_level_2',
  POSTAL_CODE: 'postal_code',
};
export const getGMapsComponent = (array, key) => {
  const filtered = array.filter((item) =>
    item.types.some((type) => Object.values(GMAPS_TYPES).includes(type))
  );
  return filtered.find((item) => item.types.includes(key)) || null;
};

export const getGMapsAddressString = (array) => {
  const filtered = array.filter((item) =>
    item.types.some((type) => Object.values(GMAPS_TYPES).includes(type))
  );

  let provincia = '';
  let codigoPostal = '';
  let direccion = '';

  filtered.forEach((item) => {
    if (item.types.includes(GMAPS_TYPES.PROVINCE)) {
      provincia = item.long_name;
    } else if (item.types.includes(GMAPS_TYPES.POSTAL_CODE)) {
      codigoPostal = item.long_name;
    } else if (item.types.includes(GMAPS_TYPES.ROUTE)) {
      direccion = item.long_name;
    }
  });

  return `Provincia: ${provincia}, Código postal: ${codigoPostal}, Dirección: ${direccion}`;
};
